import { render, staticRenderFns } from "./openvip.vue?vue&type=template&id=3ceb8c4d&scoped=true&"
import script from "./openvip.vue?vue&type=script&lang=js&"
export * from "./openvip.vue?vue&type=script&lang=js&"
import style0 from "./openvip.vue?vue&type=style&index=0&lang=css&"
import style1 from "./openvip.vue?vue&type=style&index=1&id=3ceb8c4d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ceb8c4d",
  null
  
)

export default component.exports